import { render, staticRenderFns } from "./paperConfig.vue?vue&type=template&id=19464570&scoped=true"
import script from "./paperConfig.vue?vue&type=script&lang=js"
export * from "./paperConfig.vue?vue&type=script&lang=js"
import style0 from "./paperConfig.vue?vue&type=style&index=0&id=19464570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19464570",
  null
  
)

export default component.exports